import {
  CustomerComponentName,
  LayoutConfiguration,
} from '@livekatsomo/models';
import { defaultCustomerLayoutConfiguration } from '@livekatsomo/shared/config';
import {
  RenderLayout,
  defaultRenderingConfiguration,
} from '@livekatsomo/web/ui-components/layouts';
import { ReactNode } from 'react';

export interface ChannelViewContentProps {
  componentConfiguration: Record<CustomerComponentName, ReactNode>;
  layoutConfiguration?: LayoutConfiguration;
}

export function ChannelViewContent({
  componentConfiguration,
  layoutConfiguration = defaultCustomerLayoutConfiguration,
}: ChannelViewContentProps) {
  return (
    <RenderLayout
      id="baseLayout"
      layoutConfiguration={layoutConfiguration}
      components={componentConfiguration}
      renderingConfiguration={defaultRenderingConfiguration}
    />
  );
}

export default ChannelViewContent;
